import { useT } from '../../i18n/index.ts';
import { Tooltip } from '../../ui/index.ts';

export function UpstreamLabel({
  upstreamId,
  name,
  region,
}: {
  readonly upstreamId: string;
  readonly name: string | null | undefined;
  readonly region?: string | null;
}): JSX.Element {
  const t = useT();
  const known = typeof name === 'string' && name.length > 0;
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-dense text-paper">
        {known ? name : upstreamId}
      </span>
      <span className="inline-flex flex-wrap items-center gap-1.5 font-mono text-micro text-paper-low">
        {known ? (
          <Tooltip content={upstreamId}>
            <span className="cursor-copy">{upstreamId}</span>
          </Tooltip>
        ) : (
          <span>{t('egress_lines.traffic.upstream_unknown')}</span>
        )}
        {typeof region === 'string' && region.length > 0 ? (
          <span className="uppercase">{region}</span>
        ) : null}
      </span>
    </div>
  );
}
